import { render } from "./BusinessEthics.vue?vue&type=template&id=060570a1&scoped=true"
import script from "./BusinessEthics.vue?vue&type=script&lang=js"
export * from "./BusinessEthics.vue?vue&type=script&lang=js"

import "./BusinessEthics.vue?vue&type=style&index=0&id=060570a1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-060570a1"]])

export default __exports__